import { render } from "./index.vue?vue&type=template&id=dc2e6aee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=dc2e6aee&lang=scss&scoped=true"

import exportComponent from "/Users/malik/Sites/ismatgroup-satisfaction/front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc2e6aee"]])

export default __exports__